var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { config, metadata, metadataOf } from "./metadata";
import { SoaContext } from "./provider";
import { invoke, invokeAll } from "./invoke";
import { throttle } from "./throttle";
import { debounce } from "./debounce";
import { EventBus } from "./event-bus";
import { h } from "preact";
export function Service(target) {
    var id = config.counter++;
    config.services[id] = target;
    metadata(target.prototype, { id: id, channel: new EventBus() });
    Object.defineProperty(target.prototype, 'serviceId', {
        configurable: false,
        enumerable: true,
        writable: false,
        value: id,
    });
    return target;
}
export function Hub(target) {
    var id = config.counter++;
    config.services[id] = target;
    metadata(target.prototype, { id: id, hub: true, channel: new EventBus() });
    Object.defineProperty(target.prototype, 'serviceId', {
        configurable: false,
        enumerable: true,
        writable: false,
        value: id,
    });
    return target;
}
export function observable(target, key) {
    var _a = metadataOf(target).observables, observables = _a === void 0 ? [] : _a;
    metadata(target, {
        observables: __spreadArrays(observables, [
            key
        ])
    });
}
export function pick(target, base) {
    if (!!base) {
        var meta = metadataOf(target.prototype);
        if (!!base.__context__) {
            return base.__context__.services[meta.id];
        }
        if (!!base.context) {
            return base.context.services[meta.id];
        }
        return null;
    }
    else {
        return Object.create(target);
    }
}
export function createStore() {
    var _this = this;
    var container = {};
    container.updates = new EventBus();
    container.channel = new EventBus();
    container.services = config.services.map(function (cls) { return Object.create(cls.prototype); });
    for (var i = 0; i < container.services.length; i++) {
        registerService(container, container.services[i]);
    }
    container.pick = function (target) {
        var meta = metadataOf(target.prototype);
        return container.services[meta.id];
    };
    container.broadcast = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = container.channel).dispatch.apply(_a, args);
    };
    container.invoke = function (target, name) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, invoke.apply(void 0, __spreadArrays([container, target, name], args))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); });
    };
    container.invokeAll = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, invokeAll.apply(void 0, __spreadArrays([container, 'all', name], args))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); });
    };
    container.invokeLinear = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, invokeAll.apply(void 0, __spreadArrays([container, 'linear', name], args))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); });
    };
    container.invokeParallel = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, invokeAll.apply(void 0, __spreadArrays([container, 'parallel', name], args))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); });
    };
    container.invokeRace = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, invokeAll.apply(void 0, __spreadArrays([container, 'race', name], args))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); });
    };
    return container;
}
function registerService(container, service) {
    var _a = metadataOf(service), channel = _a.channel, triggers = _a.triggers, hub = _a.hub, _b = _a.observables, observables = _b === void 0 ? [] : _b, _c = _a.timers, timers = _c === void 0 ? [] : _c, _d = _a.wired, wired = _d === void 0 ? [] : _d, _e = _a.throttleFunctions, throttleFunctions = _e === void 0 ? [] : _e, _f = _a.debounceFunctions, debounceFunctions = _f === void 0 ? [] : _f;
    Object.defineProperty(service, '__context__', {
        value: container,
        configurable: false,
        enumerable: false,
        writable: false,
    });
    service.constructor(container);
    wired.forEach(function (key) {
        var id = metadataOf(service[key].prototype).id;
        service[key] = container.services[id];
    });
    throttleFunctions.forEach(function (data) {
        var key = data.key, options = data.options, ms = data.ms;
        var func = throttle(service[key].bind(service), ms, options);
        Object.defineProperty(service, key, {
            configurable: true,
            writable: false,
            enumerable: true,
            value: func,
        });
    });
    debounceFunctions.forEach(function (data) {
        var key = data.key, options = data.options, ms = data.ms;
        var func = debounce(service[key].bind(service), ms, options);
        Object.defineProperty(service, key, {
            configurable: true,
            writable: false,
            enumerable: true,
            value: func,
        });
    });
    timers.forEach(function (data, i) {
        var key = data.key, ms = data.ms, options = data.options;
        var timer = null;
        var startDate = null;
        var counter = 0;
        function stop() {
            clearTimeout(timer);
            timer = null;
            counter = 0;
        }
        function recall() {
            timer = setTimeout(function () {
                if (options && typeof options.count == 'number') {
                    if (++counter > options.count) {
                        stop();
                        return;
                    }
                }
                var response = service[key].call(service, startDate);
                if (response !== false) {
                    recall();
                }
            }, ms);
        }
        Object.defineProperty(service[key], 'stop', {
            writable: false,
            enumerable: true,
            value: stop,
            configurable: true,
        });
        Object.defineProperty(service[key], 'start', {
            writable: false,
            enumerable: true,
            value: function () {
                if (timer) {
                    if (options && options.single) {
                        return;
                    }
                    stop();
                }
                startDate = new Date();
                recall();
            },
            configurable: true,
        });
        if (!options || !options.stopped) {
            startDate = new Date();
            counter = 0;
            recall();
        }
    });
    function registerListener(key) {
        var alias = "$$" + key;
        Object.defineProperty(service, alias, {
            configurable: true,
            writable: false,
            enumerable: false,
            value: service[key],
        });
        Object.defineProperty(service, key, {
            configurable: true,
            enumerable: true,
            get: function () {
                return service[alias];
            },
            set: function (value) {
                if (service[alias] !== value) {
                    Object.defineProperty(service, alias, {
                        configurable: true,
                        writable: false,
                        enumerable: false,
                        value: value,
                    });
                    if (!!triggers && !!triggers[key]) {
                        triggers[key].forEach(function (name) { return service[name].call(service); });
                    }
                    channel.dispatch(key, value);
                    container.updates.dispatch(service, key, value);
                }
            }
        });
    }
    if (hub) {
        var obj_1 = Object.getOwnPropertyDescriptors(service);
        Object.keys(obj_1).forEach(function (key) {
            var item = obj_1[key];
            if (!item.enumerable || !item.writable)
                return;
            var value = item.value;
            if (typeof value === 'function')
                return;
            registerListener(key);
        });
    }
    else {
        observables.forEach(registerListener);
    }
    if (typeof service.messageReceived === 'function') {
        container.channel.listen(service.messageReceived.bind(service));
    }
}
export function SoaProvider(props) {
    return (h(SoaContext.Provider, { value: props.store }, props.children));
}
export function wired(target, key) {
    var _a = metadataOf(target).wired, wired = _a === void 0 ? [] : _a;
    metadata(target, {
        wired: __spreadArrays(wired, [
            key,
        ])
    });
}
export function Name(name) {
    return function (target) {
        metadata(target.prototype, { name: name });
        Object.defineProperty(target.prototype, 'serviceName', {
            configurable: false,
            enumerable: true,
            writable: false,
            value: name,
        });
        return target;
    };
}
export var Ordered;
(function (Ordered) {
    Ordered[Ordered["HIGHEST_PRECEDENCE"] = -999999999] = "HIGHEST_PRECEDENCE";
    Ordered[Ordered["DEFAULT"] = 0] = "DEFAULT";
    Ordered[Ordered["LOWEST_PRECEDENCE"] = 999999999] = "LOWEST_PRECEDENCE";
})(Ordered || (Ordered = {}));
export function Order(order) {
    return function (target) {
        metadata(target.prototype, { order: order });
        return target;
    };
}
var IService = /** @class */ (function () {
    function IService() {
    }
    Object.defineProperty(IService.prototype, "context", {
        get: function () {
            return this.__context__;
        },
        enumerable: false,
        configurable: true
    });
    IService.prototype.startTimer = function (timer) {
        timer.start();
    };
    IService.prototype.stopTimer = function (timer) {
        timer.stop();
    };
    IService.prototype.messageReceived = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    return IService;
}());
export { IService };
